<div class="d-flex justify-content-between align-items-center mb-3">
  <div class="row">
    <div class="col d-flex">
      <h1 class="fs-5 fw-bold mb-0">Page builder</h1>
    </div>
  </div>

  <div class="d-flex gap-2">
    <a [routerLink]="'add'" *isGranted="['ROLE_API_STATIC_PAGE_WRITE']" class="btn btn-primary fw-bold"><i
      class="bi bi-plus-lg me-2"></i>Add new page</a>
  </div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="d-flex gap-3 align-items-center mb-3">
      <input type="text" [(ngModel)]="filters.values['name']" (ngModelChange)="onNameChange()" class="form-control" placeholder="Filter by name" style="padding: 11px;">

      <app-dropdown-select [(ngModel)]="filters.values['productId']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by brand" class="form-control">
        @for (product of products; track product.id) {
          <app-dropdown-select-option [value]="product.id">{{ product }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['lang']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by lang" class="form-control">
        @for (lang of languages; track lang.isoCode) {
          <app-dropdown-select-option [value]="lang.isoCode">{{ lang.name }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['pageTypeId']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by type" class="form-control">
        @for (pageType of pageTypes; track pageType.id) {
          <app-dropdown-select-option [value]="pageType.id">{{ pageType }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['userId']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by author" class="form-control">
        @for (user of users; track user.id) {
          <app-dropdown-select-option [value]="user.id">{{ user }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <button type="button" class="btn btn-outline-primary ms-2" (click)="filters.saveFilters()" title="Save filters">
        <i class="bi bi-floppy"></i>
      </button>
      <button type="button" class="btn btn-outline-secondary ms-2" (click)="filters.clearFilters()" title="Clear filters">
        <i class="bi bi-eraser"></i>
      </button>
    </div>

    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead class="bg-tertiary">
        <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
          <th tableSorterHeader="id">ID</th>
          <th tableSorterHeader="name">Name</th>
          <th tableSorterHeader="pageType">Type</th>
          <th>Link</th>
          <th>Brand</th>
          <th>Language</th>
          <th tableSorterHeader="publishedAt">Published</th>
          <th tableSorterHeader="createdAt">Created</th>
          <th>Modified</th>
          <th tableSorterHeader="user">Author</th>
          <th tableSorterHeader="status">Status</th>
          <th class="text-end">Action</th>
        </tr>
        </thead>
        <tbody>
        @for (staticPage of staticPages; track staticPage.id) {
          <tr>
            <td>{{ staticPage.id }}</td>
            <td>{{ staticPage.name }}</td>
            <td>{{ staticPage.pageType }}</td>
            <td>
              @if (staticPage.status === StaticPageStatus.ACTIVE && staticPage.isPublished()) {
                <a [href]="staticPage.getLink()" target="_blank">
                  {{ staticPage.getLink() }}
                </a>
              } @else {
                @if (staticPage.status !== StaticPageStatus.ACTIVE) {
                  <span class="badge bg-danger me-2">Status {{ staticPage.status }}</span>
                }
                @if (staticPage.publishedAt === null) {
                  <span class="badge bg-danger">No publication date</span>
                } @else if (!staticPage.isPublished()) {
                  <span class="badge bg-danger">Not yet published ({{ staticPage.publishedAt | date:'dd MMM yyyy HH:mm' }})</span>
                }
              }
            </td>
            <td>{{ staticPage.product }}</td>
            <td>{{ staticPage.locale }}</td>
            <td>{{ staticPage.publishedAt | date:'dd MMM yyyy HH:mm' }}</td>
            <td>{{ staticPage.createdAt | date:'dd MMM yyyy' }}</td>
            <td>{{ staticPage.updatedAt | date:'dd MMM yyyy' }}</td>
            <td>{{ staticPage.user }}</td>
            <td>
              @switch (staticPage.status) {
                @case (StaticPageStatus.ACTIVE) {
                  <span class="badge bg-success"><i class="bi bi-check-circle me-2"></i>Active</span>
                }
                @case (StaticPageStatus.PENDING) {
                  <span class="badge bg-warning"><i class="bi bi-hourglass me-2"></i>Pending</span>
                }
                @case (StaticPageStatus.DISABLED) {
                  <span class="badge bg-danger"><i class="bi bi-x-circle me-2"></i>Disabled</span>
                }
              }
            </td>
            <td class="text-end">
              @if (staticPage.scope === 'public' || ownsStaticPage(staticPage)) {
                <a class="btn btn-outline-primary btn-sm" [routerLink]="[staticPage.id]">
                  <i class="bi bi-pencil me-1"></i>Edit
                </a>
                <button class="btn btn-outline-secondary btn-sm ms-1" (click)="duplicate(staticPage)">
                  <i class="bi bi-copy me-1"></i>Duplicate
                </button>
              }
              @if ((staticPage.scope === 'public' || ownsStaticPage(staticPage)) && staticPage.scope !== 'protected') {
                @if (staticPage.scope === 'public') {
                  <button class="btn btn-outline-danger btn-sm ms-1" (click)="confirmDelete(staticPage)">
                    <i class="bi bi-trash"></i>
                  </button>
                } @else {
                  <button class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(staticPage)">
                    <i class="bi bi-trash"></i>
                  </button>
                }
              }
            </td>
          </tr>
        }
        </tbody>
      </table>

      <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
